import './App.css';
import Footer from './components/Footer/Index';
import HomePagina from './components/HomePage/Index';
import NavigatieBar from './components/NavigatieBar/Index';
import YogaOpWerk from './components/YogaOpHetWerkPage/Index';
import YogaAanHuis from './components/YogaAanHuisPage/Index';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import WoordenBoek from './components/WoordenBoekPage/Index';
import ContactPage from './components/ContactPage/Index';
import Tarieven from './components/TarievenPage/Index';
import ThankYou from './components/ThankYouPage/Index';
import BlogPagina from './components/BlogPage/Index';
import OverMij from './components/OverMijPage/Index';
import WatIsYoga from './components/WatIsYogaPage/Index';
import BlogDetail from './components/BlogDetailPage/Index';

import { BlogProvider } from './context/BlogContext';
import BlogRealtimeListener from './ProductRealTimeListener/BlogRealTimeListener';
import NotFound from './components/NotFoundPage/Index';

function App() {
  return (
    <BlogProvider>
      <BlogRealtimeListener />
      <Router>
        <ScrollToTop />
        <div className="App">

          <NavigatieBar />

          <Routes>
            <Route path="/" element={<HomePagina />} />
            <Route path="/privelessen" element={<YogaAanHuis />} />
            <Route path="/yogavoorbedrijven" element={<YogaOpWerk />} />
            <Route path="/woordenboek" element={<WoordenBoek />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/tarieven" element={<Tarieven />} />
            <Route path="/overmb" element={<HomePagina />} />
            <Route path="/aanbod" element={<HomePagina />} />
            <Route path="/bedankt" element={<ThankYou />} />
            <Route path="/blog" element={<BlogPagina />} />
            <Route path="/overmij" element={<OverMij />} />
            <Route path="/watisyoga" element={<WatIsYoga />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>

          <Footer />

        </div>
      </Router>
    </BlogProvider>
  );
}

export default App;